import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noOptions: {
    defaultMessage: 'No options',
    description: 'Message shown when searching the options in a dropdown yields no results',
    id: 'P4GZot',
  },
});
